import { Navigate, RouteObject } from 'react-router-dom';
import HomePage from './home-page-component';
import WORKSPACE_ROUTES from '../workspace/workspace-routes';
import PlatformStudioPage from 'modules/studio/pages/PlatformStudioPage';
import SERVICE_PORTAL_ROUTES from 'modules/service-portal/routers/ServicePortalRouter';
import FLUSS_ROUTES from 'modules/fluss/routers/FlussRouter';
import ColumnOverridePage from 'modules/record/record-related-list/pages/ColumnOverridePage';
import FormBuilderPage from 'modules/form-builder/FormBuilderPage';

const HOME_PAGE_ROUTES: RouteObject[] = [
    {
        index: true,
        element: <Navigate to="home" />
    },
    {
        path: "home",
        element: (
            <HomePage />
        ),
        children: [
            {
                path: "",
                element: <Navigate to="workspace" />
            },
            {
                path: "studio",
                element: <PlatformStudioPage />
            },
            {
                path: "column-override/:tableId/:columnId",
                element: <ColumnOverridePage />
            },
            { path: "form-builder", element: <FormBuilderPage /> },
            { path: "form-builder/:tableName", element: <FormBuilderPage /> },
            { path: "form-builder/:tableName/:viewId", element: <FormBuilderPage /> },
            ...SERVICE_PORTAL_ROUTES,
            ...FLUSS_ROUTES,
            ...WORKSPACE_ROUTES
        ],
    }
];

export default HOME_PAGE_ROUTES;
